'use client';

import { BonusNotWageringInfo } from '@/features/bonus-not-wagering/bonus-not-wagering-info';
import { useGameAccessCheck } from '@/shared/hooks/useGameAccessCheck';
import { useGameByRoute } from '@/entities/game/model/api';
import { WarningContainer } from './styles';

type RouteParam = string | string[] | undefined;

interface HeaderGameBonusWarningProps {
  categories?: RouteParam;
  titleGame?: RouteParam;
}

const getRouteParam = (value?: RouteParam) => {
  if (Array.isArray(value)) return value[0];
  return value;
};

const HeaderGameBonusWarning = ({
  categories,
  titleGame,
}: HeaderGameBonusWarningProps) => {
  const providerId = getRouteParam(categories);
  const gameCode = getRouteParam(titleGame);
  const { game: findInfoGame } = useGameByRoute(providerId, gameCode);
  const accessHelpers = useGameAccessCheck();

  const isGameDisabled = accessHelpers.isDisabled(findInfoGame);

  if (!findInfoGame || !isGameDisabled) return null;

  return (
    <WarningContainer>
      <BonusNotWageringInfo game={findInfoGame} />
    </WarningContainer>
  );
};

export { HeaderGameBonusWarning };
